import { DataImportTypeIds } from '../../utils/constants';

export const SCORE_UPDATE_SUCCESS_COPY = {
    header: 'Thanks for letting us know!',
    details: 'We’re working to resolve the issue. Check back in 48 hours.',
};

const IMPORTED_SOURCE_COPY = {
    [DataImportTypeIds.USTA_TOURNAMENTS]: {
        header: 'Action Needed: Score Update',
        details: 'Please have the tournament director update the score on the USTA site first. Our system should sync approximately 24 hours after that update. If the score still doesn\'t update on our site after that time, please share the URL where the correct score is displayed.',
    },
    [DataImportTypeIds.USTA_LEAGUES]: {
        header: 'Action Needed: Score Update',
        details: 'Please have the team captain update the score on the USTA site first. Our system should sync approximately 24 hours after that update. If the score still doesn\'t update on our site after that time, please share the URL where the correct score is displayed.',
    },
};

const UNKNOWN_SOURCE_COPY = {
    header: 'We need more information',
    details: 'Please share the URL with the correct score, and we\'ll update it within 48 hours.',
};

export const getIncorrectScoreMessage = (dataImportTypeId) => (
    IMPORTED_SOURCE_COPY[dataImportTypeId] ?? UNKNOWN_SOURCE_COPY
);

// The URL is only asked for when the result came from an import, so the source that owns the
// correct score is somewhere the user can link to.
export const shouldShowSourceUrlInput = (dataImportTypeId) => dataImportTypeId != null;
